// extracted by mini-css-extract-plugin
module.exports = {"scroll_to_next":"style_scroll_to_next__CY9Co","arrow":"style_arrow__239up","scroll-text":"style_scroll-text__2uZsI","bounce":"style_bounce__1-2KX"};